import React from 'react';
import './footer.scss';
import { FOOTER_MENU } from '../../../feature/account/accounts.routes';
import Icon from '../Icon/Icon';
import { Link } from 'react-router-dom';

const Footer = props => (
  <div className="footer">
    {FOOTER_MENU.map(menu => {
      return (
        <Link
          to={menu.url}
          className="footer--link justify-content--space-between"
          key={menu.key}
        >
          <Icon
            class={`${menu.icon} footer--link--icon flex-shrink-0`}
            size={17}
          />
          <div className="footer--link--title">{menu.title}</div>
          <Icon class="icon-common-red-arrow-right flex-shrink-0" size={10} />
        </Link>
      );
    })}
  </div>
);

export default Footer;
